import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreventDefaultDirective } from './prevent-default.directive';



@NgModule({
  declarations: [
    PreventDefaultDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PreventDefaultDirective
  ]
})
export class PreventDefaultModule { }
